import React from 'react';
import { formatValueIfNullOrUndefined } from 'utilities/util';
import { PropertiesRibbonWrapper } from 'components/properties-ribbon';

interface ITopBarOwnProps {
    serviceContractNumber: string;
    cblReferenceNumber: string;
    portOfLoading: string;
    placeOfReceipt: string;
    portOfDischarge: string;
    placeOfDelivery: string;
    vessel: string;
    voyage: string;
    eta: string;
    etd: string;
    isActionHidden: boolean;
}

export const DetailsTopBar: React.FunctionComponent<ITopBarOwnProps> = (props) => {
    const propertiesRibbonData = {
        labels: [
            { label: 'Service Contract Number', value: formatValueIfNullOrUndefined(props.serviceContractNumber), key:`cbls-serviceContractNumber`  },
            { label: 'CB Reference Number', value: formatValueIfNullOrUndefined(props.cblReferenceNumber), key:`cbls-cblReferenceNumber`  },// carrierBookingReference
            { label: 'Vessel', value: formatValueIfNullOrUndefined(props.vessel), key:`cbls-vessel` },
            { label: 'Voyage', value: `${formatValueIfNullOrUndefined(props.voyage)}`, key:`cbls-volume` },
            { label: 'ETD', value: formatValueIfNullOrUndefined(props.etd), key:`cbls-etd` },
            { label: 'Place of Receipt', value: formatValueIfNullOrUndefined(props.placeOfReceipt), key:`cbls-placeOfReceipt` },
            { label: 'Port of Loading', value: formatValueIfNullOrUndefined(props.portOfLoading), key:`cbls-portOfLoading` },
            { label: 'Port of Discharge', value: formatValueIfNullOrUndefined(props.portOfDischarge), key:`cbls-portOfDischarge` },
            { label: 'Place of Delivery', value: formatValueIfNullOrUndefined(props.placeOfDelivery), key:`cbls-placeOfDelivery` },
            { label: 'ETA', value: formatValueIfNullOrUndefined(props.eta), key:`cbls-packages` }
        ],
        actions: [],
        isActionHidden: props.isActionHidden
    }
    return (
        <React.Fragment>
            <PropertiesRibbonWrapper content={propertiesRibbonData} key={`-CBLDetailsTopBar-${Math.random()}`}/>
        </React.Fragment>
    )
};